import React from 'react';
interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
}
export function SectionTitle({
  eyebrow,
  title,
  subtitle
}: SectionTitleProps) {
  return <div className="mx-auto mb-10 max-w-3xl text-center" data-id="element-3">
      {eyebrow ? <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-rose-600" data-id="element-4">
          {eyebrow}
        </p> : null}
      <h2 className="text-3xl font-bold tracking-tight text-stone-900 md:text-4xl" data-id="element-5">
        {title}
      </h2>
      {subtitle ? <p className="mt-4 text-base leading-7 text-stone-600 md:text-lg" data-id="element-6">
          {subtitle}
        </p> : null}
    </div>;
}